/* eslint-disable no-unused-expressions */
import React, { useState } from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core'
import { dinamicTablesStyles } from './styles'
import HeaderFiltersTable from './HeaderFiltersTable'


const TableQuizzesScore = ({ info, groupData, modules }) => {
  const [manager, setManager] = useState('todas')
  const [boss, setBoss] = useState('todas')
  const [selectedActions, setSelectedActions] = useState('todas')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const classes = dinamicTablesStyles()

  const formatedData = groupData(info, 'socio')
  const [infoFiltered, setInfoFiltered] = useState(formatedData)

  const managers = groupData(info, 'socio').map(partner => partner[0].gerente)
  const bosses = groupData(info, 'socio').map(partner => partner[0].jefe)

  const filterArray = (type, key) => {
    const bossSelected = type === 'manager' ? key : manager
    const quizzesSelected = type === 'boss' ? key : boss
    const actionsSelected = type === 'action' ? key : selectedActions
    const newArrayBosses = bossSelected !== 'todas' ? info.filter(el => (el.jefe === bossSelected)) : info
    const newArrayQuizzes = quizzesSelected !== 'todas' ? newArrayBosses.filter(el => el[quizzesSelected] > 0) : newArrayBosses
    const newArrayActions = actionsSelected !== 'todas' ? newArrayQuizzes.filter(el => el[actionsSelected] > 0) : newArrayQuizzes
    setInfoFiltered(newArrayActions)
    // setCount(newArrayActions)
    if (type === 'action') {
      setSelectedActions(key)
    }
    setPage(0)
  };

  const handleChange = (e, type) => {
    type === 'manager' ? setManager(e.target.value) : setBoss(e.target.value)
    filterArray(type, e.target.value)
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Box className={classes.container}>
      <h3 className={classes.title}>Calificación encuestas</h3>
      <HeaderFiltersTable managers={managers} bosses={bosses} selectedActions={selectedActions} handleChange={handleChange} filterArray={filterArray}/>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell>Gerente</TableCell>
              <TableCell>Jefe</TableCell>
              <TableCell>Socio</TableCell>
              <TableCell>Encuesta</TableCell>
              {modules.map(module => (
                <TableCell align='center'>{module}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {infoFiltered.map(partner => (
              <TableRow>
                <TableCell>{partner[0].gerente}</TableCell>
                <TableCell>{partner[0].jefe}</TableCell>
                <TableCell style={{ color: '#2699FB' }}>{partner[0].socio}</TableCell>
                <TableCell>{partner[0].calificacionEncuesta}</TableCell>
                {modules.map(module => (
                  <TableCell className={classes.centeredCell}>{partner.filter(action => action.nombre === module)[0]?.calificacion || '0'}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={infoFiltered.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default TableQuizzesScore